import { LinearProgress } from '@material-ui/core'
import React from 'react'
import './styles.scss';

interface LinearProjectReportProps {
    title: string;
    completed: number;
    pending: number;
    initialAmount?: number | string;
    pendingAmount?: number | string;
}

const LinearProjectReport = ({ title, completed, pending, initialAmount, pendingAmount }: LinearProjectReportProps) => {
    return (
        <>
            <div className='container'>

                <div className="title-content">
                    <p>{title}</p>
                </div>

                <div className='c-progress-bar'>
                    <LinearProgress
                        className='linear-chart'
                        variant="determinate"
                        value={((Math.max(0, completed) / (Math.max(0, completed) + Math.max(0, pending))) || 0) * 100}
                        style={{ width: '100%', height: '15px', borderRadius: "6px" }} />


                    <div className='c-linear_porcent-data'>
                        <div className='content-data'>
                            <div className='initial-data-content'>
                                <div className='amount'>
                                    {initialAmount}
                                </div>
                            </div>
                        </div>

                        <div className='content-data'>
                            <div className='pending-data-content'>
                                <div className='amount'>
                                    {pendingAmount}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LinearProjectReport